import cityMixin from "./cityMixin";

const districtAndCity = district => {
  let isAValidDistrictWithACity =
    isAValidDistrict(district) && haveACity(district);
  return isAValidDistrictWithACity
    ? `${district.display_name} - ${district.city.display_name}`
    : "";
};

const isAValidDistrict = district => district.id && district.display_name;
const haveACity = district =>
  district.city && district.city.id && district.city.display_name;

export default {
  filters: {
    districtAndCity
  },
  methods: {
    districtAndCity
  }
};



// WEBPACK FOOTER //
// ./src/mixins/districtMixin.js